import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Comment, Typography } from "@perxis-auto/ui-kit";
import clsx from "clsx";
import styles from "./DealerComment.module.scss.js";
const DealerComment = memo(function DealerComment2({ children, className, ...props }) {
  if (!children) {
    return null;
  }
  return /* @__PURE__ */ jsx(Comment, { className: clsx(styles.dealerComment, className), ...props, children: /* @__PURE__ */ jsx(Typography.Paragraph, { level: "main", color: "dark", children }) });
});
export {
  DealerComment
};
